import { createContext, useContext } from 'react'
import type { OnboardingLayoutContext_ReferralFragment } from './useOnboardingLayoutContext.graphql'
import type { SignupInterestsEnum } from 'gql/types'

export interface IOnboardingLayoutContext {
  interestedIn: SignupInterestsEnum[]
  referrer?: OnboardingLayoutContext_ReferralFragment | null
}

const OnboardingLayoutContext = createContext<IOnboardingLayoutContext>({
  interestedIn: [],
  referrer: null,
})

export interface IOnboardingLayoutProviderProps {
  interestedIn: IOnboardingLayoutContext['interestedIn']
  referrer?: IOnboardingLayoutContext['referrer']
}

export const OnboardingLayoutProvider: Settle.FC<IOnboardingLayoutProviderProps> = ({
  children,
  interestedIn,
  referrer = null,
}) => <OnboardingLayoutContext.Provider value={{ interestedIn, referrer }}>{children}</OnboardingLayoutContext.Provider>

export const useOnboardingLayoutContext = () => useContext(OnboardingLayoutContext)
